import type React from 'react';
import { inject } from 'mobx-react';

/**
 * @deprecated Use the hook, e.g. `useView` to access the store from react context instead.
 * More documentation can be found here: https://appliedintuition.atlassian.net/wiki/spaces/eng/pages/1810760463/Frontend+State+Management#%F0%9F%91%B4--Using-legacy-MobX-stores
 */
export function strictInject<D>(
  ...stores: string[]
): <A extends D>(component: React.ComponentType<A>) => React.ComponentType<Omit<A, keyof D>> {
  return inject(...stores);
}
